@use '../../styles/mixins' as *;

// Боковая панель: та же поверхность, что у @atoms/Modal, но без скруглений по
// внешнему краю — панель приклеена к краю экрана и идёт во всю его высоту.
.rf-drawer {
    --rf-drawer-stroke: var(--theme-rf-drawer-stroke);
    --rf-drawer-text: var(--theme-rf-drawer-text);
    // стекло панели: в тёмной — приподнятая тёмная поверхность
    --rf-drawer-glass: var(--theme-rf-drawer-glass);
    --rf-drawer-scrim: var(--theme-rf-drawer-scrim);
}

.rf-drawer__bg {
    background: var(--rf-drawer-scrim);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
}

.rf-drawer__container {
    display: flex;
    flex-direction: column;
    background: var(--rf-drawer-glass);
    border-left: 1px solid var(--rf-drawer-stroke);
    box-shadow: -30px 0 80px -28px rgba(15, 28, 60, 0.35);
    color: var(--rf-drawer-text);
    overflow: hidden;
    // немодальной панели фокус ставится на неё саму; рамка вокруг всей панели ничего не подсказывает
    outline: none;
}

// Панель с отступом от краёв экрана не прилегает к нему — рамка со всех сторон.
.rf-drawer--floating .rf-drawer__container {
    border: 1px solid var(--rf-drawer-stroke);
}

.rf-drawer__header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px 12px 20px;
    background: transparent;
    flex-shrink: 0;
    min-height: 0;

    &::after {
        content: '';
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(76, 200, 255, 0.45) 25%,
            color-mix(in srgb, var(--primary-50) 50%, transparent) 50%,
            rgba(176, 140, 255, 0.45) 75%,
            transparent 100%
        );
    }
}

.rf-drawer__title {
    @include type-title-card;
    color: var(--rf-drawer-text);
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
}

.rf-drawer__header-content {
    flex: 1 1 auto;
    min-width: 0;
}

.rf-drawer__close-button {
    margin-left: auto;
}

.rf-drawer__body {
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
}

.rf-drawer__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
}

.rf-drawer__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    padding: 16px 20px 20px;
    color: var(--neutral-90);
    display: flex;
    flex-direction: column;
}

.rf-drawer__footer {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px 16px;
    flex-shrink: 0;
    background: var(--rf-drawer-glass);
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        left: 20px;
        right: 20px;
        top: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(76, 200, 255, 0.45) 25%,
            color-mix(in srgb, var(--primary-50) 50%, transparent) 50%,
            rgba(176, 140, 255, 0.45) 75%,
            transparent 100%
        );
    }
}
